import { render, staticRenderFns } from "./AGapText.vue?vue&type=template&id=08a8df35"
import script from "./AGapText.vue?vue&type=script&lang=ts"
export * from "./AGapText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports